// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Model = require("./model");
var React = require("react");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Configuration = require("./configuration");

var component = ReasonReact.statelessComponent("OrdreDuJour");

function make(legislature, organe, ordreDuJour, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h3"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Display1 */3], /* array */[Model.ste(organe)])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h4"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste("Ordre du jour")])), React.createElement("ul", undefined, $$Array.map((function (ordreDuJourItem) {
                            var urlPath = Model.discussionUrlPath(ordreDuJourItem[/* textBibard */0], ordreDuJourItem[/* textBibardSuffixe */1], Caml_format.caml_int_of_string(legislature), organe);
                            return React.createElement("li", {
                                        key: ordreDuJourItem[/* textBibard */0] + ordreDuJourItem[/* textBibardSuffixe */1]
                                      }, React.createElement("a", {
                                            href: urlPath,
                                            onClick: (function ($$event) {
                                                $$event.preventDefault();
                                                $$event.stopPropagation();
                                                return ReasonReact.Router[/* push */0](urlPath);
                                              })
                                          }, Model.ste(ordreDuJourItem[/* textTitre */2])));
                          }), ordreDuJour)));
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/ordreDuJour.re
// module id = 1680
// module chunks = 0